var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showScrollBtn
    ? _c(
        "a",
        {
          directives: [
            {
              name: "smooth-scroll",
              rawName: "v-smooth-scroll",
              value: { duration: 1000, offset: -150 },
              expression: "{ duration: 1000, offset: -150 }"
            }
          ],
          class: [
            "scroll-btn",
            { reachedTop: _vm.reachedTop, reachedBottom: _vm.reachedBottom }
          ],
          attrs: { href: "#__nuxt" }
        },
        [_vm._v("\n\n  Вверх\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a6f6600", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6f6600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/ScrollTopArrow.vue
// module id = ncNl
// module chunks = 41